import { connect } from "react-redux";
import selectors from "./selectors";
import { AppUI } from "./AppUI";

export default connect(selectors)(AppUI);
